export enum RevenueStatusEnum {
  EM_ABERTO = 1,
  PAGO = 2,
  PARCELADO = 3,
  APURACAO = 4,
  JURIDICO = 5,
  DIVIDA_ATIVA = 6,
  CANCELADO = 7,
  SUSPENSO = 8,
  PRE_PARCELADO = 9,
  PARCELAMENTO_PERDIDO = 10,
  PRE_REPACELADO = 11,
  REPARCELADO = 12,
  REPARCELAMENTO_PERDIDO = 13,
  PRE_REREPARCELADO = 14,
  REREPARCELADO = 15,
  REREPARCELAMENTO_PERDIDO = 16,
  QUITACAO_ANTECIPADA = 17,
  ANTERIOR_MIGRACAO = 18,
}
const statusList = [
  { key: "Em Aberto", value: RevenueStatusEnum.EM_ABERTO },
  { key: "Pago", value: RevenueStatusEnum.PAGO },
  { key: "Parcelado", value: RevenueStatusEnum.PARCELADO },
  { key: "Apuração", value: RevenueStatusEnum.APURACAO },
  { key: "Juridico", value: RevenueStatusEnum.JURIDICO },
  { key: "Divida Ativa", value: RevenueStatusEnum.DIVIDA_ATIVA },
  { key: "Cancelado", value: RevenueStatusEnum.CANCELADO },
  { key: "Suspenso", value: RevenueStatusEnum.SUSPENSO },

  { key: "Pré-Parcelado", value: RevenueStatusEnum.PRE_PARCELADO },
  {
    key: "Parcelamento Perdido",
    value: RevenueStatusEnum.PARCELAMENTO_PERDIDO,
  },
  { key: "Pré-Reparcelado", value: RevenueStatusEnum.PRE_REPACELADO },
  { key: "Reparcelado", value: RevenueStatusEnum.REPARCELADO },
  {
    key: "Reparcelamento Perdido",
    value: RevenueStatusEnum.REPARCELAMENTO_PERDIDO,
  },
  { key: "Pré-Rereparcelado", value: RevenueStatusEnum.PRE_REREPARCELADO },
  { key: "Rereparcelado", value: RevenueStatusEnum.REREPARCELADO },
  {
    key: "Rereparcelamento Perdido",
    value: RevenueStatusEnum.REREPARCELAMENTO_PERDIDO,
  },
  { key: "Quitação Antecipada", value: RevenueStatusEnum.QUITACAO_ANTECIPADA },
  { key: "Anterior Migração", value: RevenueStatusEnum.ANTERIOR_MIGRACAO },
];

export const RevenueStatusEnumAll = statusList.sort((a, b) => {
  if (a.key < b.key) {
    return -1;
  }
  if (a.key > b.key) {
    return 1;
  }
  return 0;
});

export const RevenueStatusList = [
  { key: 1, value: "EM_ABERTO", text: "Em Aberto" },
  { key: 2, value: "PAGO", text: "Pago" },
  { key: 3, value: "PARCELADO", text: "Parcelado" },
  { key: 4, value: "APURACAO", text: "Apuração" },
  { key: 5, value: "JURIDICO", text: "Juridico" },
  { key: 6, value: "DIVIDA_ATIVA", text: "Divida Ativa" },
  { key: 7, value: "CANCELADO", text: "Cancelado" },
  { key: 8, value: "SUSPENSO", text: "Suspenso" },

  { key: 9, value: "PRE_PARCELADO", text: "Pré-Parcelado" },
  { key: 10, value: "PARCELAMENTO_PERDIDO", text: "Parcelamento Perdido" },
  { key: 11, value: "PRE_REPACELADO", text: "Pré-Reparcelado" },
  { key: 12, value: "REPARCELADO", text: "Reparcelado" },
  { key: 13, value: "REPARCELAMENTO_PERDIDO", text: "Reparcelamento Perdido" },
  { key: 14, value: "PRE_REREPARCELADO", text: "Pré-Rereparcelado" },
  { key: 15, value: "REREPARCELADO", text: "Rereparcelado" },
  {
    key: 16,
    value: "REREPARCELAMENTO_PERDIDO",
    text: "Rereparcelamento Perdido",
  },
  { key: 17, value: "QUITACAO_ANTECIPADA", text: "Quitação Antecipada" },
  { key: 18, value: "ANTERIOR_MIGRACAO", text: "Anterior Migração" },
];
